import { render, staticRenderFns } from "./CommstrackerDomainsView.vue?vue&type=template&id=34b264ba"
import script from "./CommstrackerDomainsView.vue?vue&type=script&lang=js"
export * from "./CommstrackerDomainsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports